<template>
    <div id="content" class="w">
        <div class="lg_box">
            <img src="../../assets/picture/login_bg.jpg" width="410" height="490" class="lf_bg">
            <img src="../../assets/image/login_rma.png" width="80" height="80" class="lf_rm" id="lf_rm" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <img src="../../assets/image/minapp_qw.jpg" width="200" height="228" class="lf_rmb hid" id="lf_rmb" :style="active">
            <div id="logbox">
                <h1 class="lh1 yahei" id="lh1">设置余额支付密码</h1>
                <p v-show="showTishi">{{tishi}}</p>
                <div id="login_name" class="logx">
                    <form action="" method="post">
                        <div class="llabel">
                            <em class="ll_left">支付密码</em>
                            <input type="password" v-model="newpassword" class="llpt" value="" maxlength="6" placeholder="请输入支付密码">
                        </div>
                        <div class="llabel">
                            <em class="ll_left">确认密码</em>
                            <input type="password" v-model="password" class="llpt" value="" placeholder="确认支付密码" maxlength="6">
                        </div>
                        <div class="llabel">
                            <em class="ll_left">手机号码</em>
                            <input type="text" v-model="userInfo.tel" class="llpt" value="" placeholder="请输入手机号" maxlength="13">
                            <button @click.prevent="getCODE" class="dxm" :disabled="!show">
                                <span v-show="show">获取短信验证码</span>
                                <span v-show="!show" class="count">{{count}} s</span>
                            </button>
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">验证码:</em>
                            <input type="number" v-model="code" class="llpt" value="" placeholder="输入验证码">
                        </div>
                        <div class="">
                            <p style="color:#f00180;font-size:16px;">**** 密码必须六个字符，且同时包含字母和数字 ***</p>
                        </div>
                        <p @click="subInfo" class="log_btn yahei">立即设置</p>
                    </form>
                </div>
            </div>
            <p class="fuwu">
                登录代表同意夜樱情趣 
                <a href="javascript:;" class="U">服务协议</a>
                <a href="javascript:;" class="U">法律声明</a>
                <a href="javascript:;" class="U">隐私政策权</a>
            </p>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
export default {
    data() {
        return {
            index: -1,
            imgList: [],
            tel: "" || this.$store.state.user.tel,
            rex: /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/,
            pas: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/,
            wyz: "",
            password: "",
            newpassword: "",
            code: "",
            loadModal: false,
            text: this.$h("发送验证码"),
            modalName: "",
            num: 60,
            quhao: this.$store.state.user.quhao,
            isguolei: "0",
            config: {
                sms: {
                zfmmdxyz: "1",
                },
            },
            oldpassword: "",
            is_szzfmm: false,
            show: 'false',
            showTishi: false,
            showHid: false,
            tishi: '',
            count: '',
            active: "",
            userInfo:[],
        };
    },
    computed: {
        ...mapState({
            storeUuid: (state) => state.appUuid,
        }),
        getConfig () {
            return this.$store.state.config;
        },
    },
    mounted(){
        this.getUserInfo();
    },
    methods:{
        getUserInfo(){
            var params = {};
            params.id = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getUser.getUserInfo(params).then(res=>{
                this.userInfo = res.result;
            });
        },
        onMouseOver($event){
            this.active="display:inline"
        },
        onMouseOut($event){
            this.active="display:none"
        },
        subInfo() {
            if (this.password == "") {
                this.$alert('密码不能为空!', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            } else if (!this.$fnc.regexp(this.pas, this.password)) {
                this.$alert('密码非法,请从新输入!', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            } else if (this.newpassword != this.password) {
                this.$alert('两次输入的不一致,请从新输入', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            }else if (this.code == "") {
                this.$alert('验证码不能为空！', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            }
            var params = {};
            params.pay_password = this.$getCode(this.password);
            params.code = this.code;
            params.unicode = this.wyz;
            params.tel = this.userInfo.tel;
            params.quhao = this.quhao;
            params.old_password = this.$getCode(this.oldpassword);
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getOrder.changePayPassword(params).then((res) => {
                if (res.code == 200) {
                    this.$confirm('设置支付密码成功', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push({name:"Index"})    
                    });
                }
            });
        },
        getCODE () {
            var value = this.userInfo.tel;
            let reg = /^1[3|4|5|7|8][0-9]{9}$/; 
            if (!reg.test(value) || value === ""){
                this.$alert('请输入正确的手机号码', '提示', {
                    confirmButtonText: '确定',
                });
                return false;
            }else{
                this.sendcode();
            }
        },
        sendcode() {
            var _this = this;
            this.$api.getLogin.sendCode({ tel: this.userInfo.tel, quhao: this.quhao }).then((res) => {
                if (res.code === 200) {
                    // 验证码倒计时
                    if (!this.timer) {
                        this.count = 60;
                        this.show = false;
                        this.wyz = res.result;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= 60) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000);
                    }
                }
                });
            },
        sendduan () {
            var _this = this;
            this.$api.getLogin.sendCode({
                tel: this.userInfo.tel,
                quhao: this.quhao,
            }).then((res) => {
                // 验证码倒计时
                if (!this.timer) {
                    this.count = 60;
                    this.show = false;
                    this.wyz = res.result;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= 60) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            });
        },
    }
}
</script>

<style scoped>
.lg_box{border:1px solid #f1f1f1;position:relative;padding:0 0 0 500px;/*height:490px;*/overflow:hidden;box-shadow:0px 3px 10px #f1f1f1;background-color:#fff;margin: 70px 0 120px 0;}
.lf_bg{position:absolute;left:0;top:0;}
.lh1{font-size:35px;color:#000;line-height:45px;margin:40px 40px 0 0;}
.logx{padding:20px 0 0 0;width:400px;}
.llabel{line-height:60px;height:60px;position:relative;border:1px solid #f0f0f0;padding:0 0 0 92px;border-radius:4px;margin-bottom:10px;overflow:hidden;}
.ll_left{position:absolute;left:15px;top:0;line-height:60px;font-size:16px;color:#333;}
.llpt{width:100%;height:60px;border:0;color:#000;font-size:16px;line-height:60px;vertical-align:top;}
.dxm{position:absolute;color:#6b73f7;right:0;top:0;border:0;background-color:#fff;height:60px;border-left:1px solid #f0f0f0;width:130px;text-align:center;cursor:pointer;}
.log_btn{background-color:#4c62fc;color:#fff;line-height:60px;border-radius:8px;text-align:center;font-size:18px;margin:40px 0 30px 0;border:none;box-shadow:0px 1px 8px #7a89f2;cursor:pointer;}
.fuwu{text-align:center;font-size:12px;color:#ccc;line-height:60px;width:60%;}
.U{color:#ccc;padding:0 4px;}
.ck_a{color:#999;line-height:34px;display:inline-block;margin:0 5px;border:1px solid #f1f1f1;border-radius:20px;padding:0 14px;*display:inline;zoom:1;}
.lgxx{text-align:center;line-height:30px;margin:90px 0 0 20px;width:60%;}
.f0{font-size:0px;text-align:center;}
.lg_btn{background-color:#e0e1e3;border-radius:8px;line-height:50px;text-align:center;width:40%;color:#888;display:inline-block;margin:0 10px;font-size:14px;}
.lg_btnr{background-color:#4c62fc;color:#fff;}
.fb_d{border-color:#fff;}
.lf_rm,.lf_rmb{position:absolute;right:0;top:0;z-index:1;}
.lf_rmb{z-index:2;}
p{color:red;}
</style>


// WEBPACK FOOTER //
// src/components/car/pay_password.vue